import { Component, OnInit } from '@angular/core';
import { LicenseData } from '../models/LicenseData';
import { LicenseService } from '../shared/licens.service';
import { ApiService } from '../shared/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserData } from '../models/UserData';
import { PeerData } from '../models/PeerData';

@Component({
  selector: 'app-roles',
  templateUrl: 'roles.component.html',
  styleUrls: ['./roles.component.less', '../shared/common.less'],
})

export class RolesComponent implements OnInit {
  suspended: PeerData[] = [];
  filteredVoters: PeerData[] = [];
  pollId: string | null = null;
  selectedAccount: any = null;
  selectedProfile: string = 'all';
  searchQuery: string = '';
  accountName: string = "";
  maxVoters: number = 5;
  hasHotline: boolean = false;
  shouldBuyCredits: boolean = false;
  language: string = 'fr';
  hotlinePopup: boolean = false;
  resendPopupVisible: boolean = false;
  resendInviteToMail: string = '';
  resentPopupVisible: boolean = false;
  resendInviteMessage: string = '';
  disablePopupVisible: boolean = false;
  enablePopupVisible: boolean = false;
  disableContact = '';
  hasBeenDisabled: boolean = false;
  hasBeenEnabled: boolean = false;
  addUserPopup: boolean = false;
  addUserFailedPopup: boolean = false;
  userAddedPopup: boolean = false;
  deleteUserPopupVisible: boolean = false;
  userAddedData: UserData = {
    lastName: '',
    firstName: '',
    email: '',
    sendInvitation: false,
    profile: -1
  };
  changeProfilePopupVisible: boolean = false;
  changeProfileConfirmationPopup: boolean = false;
  userToChange: PeerData = new PeerData({ email: '', profile: 0 });
  newProfile: number = -1;
  contactToDelete: PeerData = new PeerData({ email: '', profile: -1, id: '' });
  userToDeactivate: PeerData = new PeerData({ email: '', profile: -1, id: '' });

  constructor(
    public licenseService: LicenseService,
    private router: Router,
    private apiService: ApiService,
    public route: ActivatedRoute,


  ) {
  }

  countUserByProfile(profile: number): number {
    return this.suspended.filter(voter => voter.profile === profile).length;
  }

  applyFilters() {
    let result = [...this.suspended];

    // Appliquer le filtre de profil
    if (this.selectedProfile !== 'all') {
      const profileNumber = parseInt(this.selectedProfile, 10);
      result = result.filter(v => v.profile === profileNumber);
    }

    // Appliquer le filtre de recherche
    if (this.searchQuery) {
      const query = this.searchQuery.trim().toLowerCase();
      result = result.filter(v =>
        v.firstName?.toLowerCase().includes(query) ||
        v.lastName?.toLowerCase().includes(query)
      );
    }

    this.filteredVoters = result;
  }

  filterByProfile(value: string) {
    this.selectedProfile = value;
    this.applyFilters();
  }

  onSearch(value: string) {
    this.searchQuery = value;
    this.applyFilters();
  }

  changeSubscription() {
    // this.shoulDisplayChangePopup = true;
    // this.smsAdditionalOption = true;
  }

  navigateArrow() {
    this.router.navigate(['/profile']);
  }

  downloadGuide() {
    switch (this.language) {
      case 'fr': { window.open('https://medium.com/fr-guides-v8te', '_blank'); return; }
      case 'es': { window.open('https://medium.com/es-gu%C3%ADas-v8te', '_blank'); return; }
      default: { window.open('https://medium.com/en-v8te-guides', '_blank'); return; }
    }
  }

  downloadDocuments() {
    window.open('https://drive.google.com/drive/folders/1sP4ShTvOKcAU0fkFeNoibJCLao-pZfQC?usp=sharing', '_blank');
  }

  setSelectedVoter($event: any) {
    this.selectedAccount = $event;
  }

  handleProfileChange(email: string) {
    const user = this.suspended.find(v => v.email === email);
    if (user) {
      this.userToChange = user;
      this.changeProfilePopupVisible = true;
    } else {
      console.error('Utilisateur non trouvé:', email);
    }
  }

  dismissProfileChangePopup() {
    this.changeProfilePopupVisible = false;
  }

  dismissConfirmationProfileChangePopup() {
    this.changeProfileConfirmationPopup = false;
  }

  getRoleIndex(role: string): number {
    switch (role) {
      case 'HR': return 0;
      case 'Assessor': return 1;
      case 'Representative': return 2;
      case 'Shared': return 3;
      default: return -1;
    }
  }

  getPeersList() {
    this.apiService.getPeers().subscribe(res => {
      this.suspended = (res as any[]).map((peer: any) => new PeerData({ email: peer.email, profile: this.getRoleIndex(peer.role), id: peer.id, firstName: peer.firstName, lastName: peer.lastName }));
      this.applyFilters();
    }, error => {
      console.error('Erreur lors de la récupération des pairs:', error);
    });
  }

  addPeer(email: string, role: string, firstName: string, lastName: string) {
    this.apiService.addPeer(email, role, firstName, lastName).subscribe(res => {
      this.getPeersList();
    }, error => {
      this.addUserFailedPopup = true;
    });
  }

  changeUserProfile($event: number) {
    this.newProfile = $event;
    this.changeProfilePopupVisible = false;
    this.apiService.changePeerRole(this.userToChange.id, this.getRoleByIndex($event)).subscribe(res => {
      this.changeProfileConfirmationPopup = true;
      this.getPeersList();
    }, error => {
      console.error('Erreur lors du changement de rôle:', error);
    });
    this.userToChange = new PeerData({ email: '', profile: 0 });
  }

  handleInvitationResend(email: string) {
    this.resendInviteToMail = email;
    this.resendPopupVisible = true;
  }

  dismissHandleInvitationResend() {
    this.resendInviteToMail = '';
    this.resendPopupVisible = false;
  }

  sentInvitation(message: string) {
    this.resendPopupVisible = false;
    this.resentPopupVisible = true;
    this.resendInviteMessage = message;
  }

  dismissInvitationSent() {
    this.resendInviteToMail = '';
    this.resendInviteMessage = '';
    this.resentPopupVisible = false;
  }

  handleDeactivation(value: { email: string, activate: boolean }) {
    const user = this.suspended.find(v => v.email === value.email);
    if (user) {
      this.userToDeactivate = user;
      console.log(this.userToDeactivate.email);

      if (!value.activate) {
        this.disablePopupVisible = true;
      } else {
        this.enablePopupVisible = true;
      }

    } else {
      console.error('Utilisateur non trouvé:', value.email);
    }
  }

  dismissDeactivationPopup() {
    this.disablePopupVisible = false;
  }

  switchUserActiveState($event: boolean) {
    this.apiService.changePeerActive(this.userToDeactivate.id, $event).subscribe(res => {
      this.dismissDeactivationPopup();
    }, error => {
      console.error('Erreur lors de la désactivation du pair:', error);
    });
    if (!$event) {
      this.hasBeenDisabled = true;
      this.disablePopupVisible = false;
    } else {
      this.hasBeenEnabled = true;
      this.enablePopupVisible = false;
    }

  }

  dismissDisabledPopup() {
    this.userToDeactivate = new PeerData({ email: '', profile: -1, id: '' });
    this.hasBeenDisabled = false;
    this.getPeersList();
  }

  dismissEnabledPopup() {
    this.userToDeactivate = new PeerData({ email: '', profile: -1, id: '' });
    this.hasBeenEnabled = false;
    this.getPeersList();
  }

  openDeletePopup(peer: PeerData) {
    this.contactToDelete = peer;
    this.deleteUserPopupVisible = true;
  }

  handleProfileRemoval(peer: PeerData) {
    this.apiService.deletePeer(peer.id).subscribe(res => {
      this.contactToDelete = new PeerData({ email: '', profile: -1, id: '' });
      this.deleteUserPopupVisible = false;
      this.getPeersList();
    }, error => {
      console.error('Erreur lors de la récupération des pairs:', error);
    });
  }

  dismissAddUserPopup() {
    this.addUserPopup = false;
  }
  dismissDeleteUserPopup() {
    this.deleteUserPopupVisible = false;
  }

  getRoleByIndex(index: number): string {
    switch (index) {
      case 0: return 'HR';
      case 1: return 'Assessor';
      case 2: return 'Representative';
      case 3: return 'CP';
      default: return 'Unknown';
    }
  }

  onUserAdded(userData: UserData) {
    this.addPeer(userData.email, this.getRoleByIndex(userData.profile), userData.firstName, userData.lastName);
    this.addUserPopup = false;
    this.userAddedPopup = true;
    this.userAddedData = userData;
  }

  dismissUserAddedPopup() {
    this.userAddedPopup = false;
  }

  dismissAddUserFailedPopup() {
    this.addUserFailedPopup = false;
  }

  contactMail() {
    const mailText = 'mailto:support_client@v8te.com';
    window.open(mailText);
  }

  initData() {
    this.licenseService.license.subscribe((res: LicenseData) => {
      if (res != null) {
        // this.remainingLicense = res.events;
        // this.licencesReady = true;
        this.maxVoters = res.votes;
        this.hasHotline = res.hasHotline;
        // if (res.hasSMS === true) { this.sms = '- ' + res.sms + ' SMS'; }
        // else { this.sms = ''; }
        // this.clientType = res.client;
        // if (res.client !== null) { this.isAssoc = res.client !== 'corp'; }
        // this.licenseTime = this.common.licenseResponseGetTime(res);
        // this.hasSmsVoters = res.sms > 5;
      }
      // this.auth.currentUser.subscribe((usr) => {
      //   this.accountName = this.auth.getUserData();
      // });
    });
    this.licenseService.refreshLicense();
    // this.apiService.getPolls(this.common.getLangCode()).subscribe((res: PollDashboardResponse) => {
    //   this.route.queryParams.subscribe((params) => {
    //     if (params.session_id === undefined) {
    //       this.shouldDisplayPopup = res.finished.length === 0 && res.ongoing.length === 0 && res.planned.length === 0;
    //     }
    //   });
    // });
    // this.route.queryParams.subscribe((params) => {
    //   if (params.session_id != null) {
    //     this.apiService
    //       .getSubscriptionData(params.session_id)
    //       .subscribe((res: Array<SubsciptionData>) => {
    //         if (res.length > 0 && res[0].type === 'H') { this.hotlineConfirmation = true; }
    //         else { this.shouldDisplayNewLicences = true; }
    //         this.newLicences = res;
    //       });
    //   }
    //   if (params.draft != null) {
    //     this.apiService.getDraft(params.draft, false).subscribe((res: DraftForm) => {
    //       const draftPoll: Poll = JSON.parse(res.data);
    //       this.currentPoll = this.createWatchedPoll(draftPoll);
    //       if (res.papValues != null) {
    //         this.papValues = JSON.parse(res.papValues);
    //       }
    //     });
    //   }
    // });
  }


  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.pollId = params.get('id');

    })

    this.getPeersList();


    const userLang = navigator.language;
    this.language = userLang.substring(0, 2);
    this.filteredVoters = [...this.suspended];
  }
}
